import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Shared wizard footer navigation: Back + Continue side-by-side.
 *
 * Presented at the bottom of every wizard step so the customer can always
 * step backwards or forwards without hunting for the header back arrow.
 * State preservation is handled by the parent (all answers/selections/photos
 * live in the RequestWizard parent, so navigating back never resets them).
 *
 * @param {() => void} onBack       Handler to move to the previous step
 * @param {() => void} onContinue   Handler to move to the next step
 * @param {boolean} continueDisabled  Disable the Continue button
 * @param {string} continueLabel    Label for the Continue button
 * @param {string} continueTestId   data-testid for the Continue button
 * @param {boolean} showBack        Whether to render the Back button
 */
export const WizardNavigation = ({
  onBack,
  onContinue,
  continueDisabled = false,
  continueLabel = 'Continue',
  continueTestId = 'wizard-continue',
  showBack = true
}) => {
  return (
    <div className="flex items-center gap-3 mt-6" data-testid="wizard-navigation">
      {showBack && (
        <Button
          variant="outline"
          onClick={onBack}
          className="flex-1 border-gray-200 text-[#1F2933] py-6 rounded-xl hover:bg-gray-50"
          data-testid="wizard-back"
        >
          <ArrowLeft className="w-5 h-5 mr-2" /> Back
        </Button>
      )}
      <Button
        onClick={onContinue}
        disabled={continueDisabled}
        className={`${showBack ? 'flex-[2]' : 'w-full'} bg-[#0FA3B1] hover:bg-[#0D8C98] text-white py-6 rounded-xl disabled:opacity-50`}
        data-testid={continueTestId}
      >
        {continueLabel} <ArrowRight className="w-5 h-5 ml-2" />
      </Button>
    </div>
  );
};

export default WizardNavigation;
